import React from "react";
import CrudPage, { Badge } from "@/components/CrudPage";
import { formatDate, deadlineLabel } from "@/lib/format";

const CATEGORIES = ["Ugovori o radu", "Poslovno-tehnička saradnja", "Najam prostora", "Registracija vozila", "6-mjesečni pregled", "Tehničko-eksploatacioni uslovi", "Vatrogasni aparati", "Ugovor o zajmu", "Servis opreme", "Ostalo"];
const STATUS = ["Aktivno", "Završeno"];

export default function Deadlines() {
  const columns = [
    { key: "title", label: "Naziv roka", render: (r) => <span className="font-medium">{r.title}</span> },
    { key: "category", label: "Kategorija", render: (r) => <Badge tone="muted">{r.category}</Badge> },
    { key: "due_date", label: "Datum roka", render: (r) => formatDate(r.due_date), export: (r) => r.due_date },
    {
      key: "_remaining", label: "Preostalo",
      render: (r) => {
        if (r.status === "Završeno") return <Badge tone="success">Završeno</Badge>;
        const l = deadlineLabel(r.due_date);
        return <Badge tone={l.tone}>{l.text}</Badge>;
      },
      export: (r) => (r.status === "Završeno" ? "Završeno" : deadlineLabel(r.due_date).text),
    },
    { key: "status", label: "Status", render: (r) => <Badge tone={r.status === "Završeno" ? "success" : "info"}>{r.status}</Badge> },
    { key: "note", label: "Napomena" },
  ];

  const fields = [
    { key: "title", label: "Naziv roka", full: true, required: true },
    { key: "category", label: "Kategorija", type: "category", categoryType: "rokovi" },
    { key: "due_date", label: "Datum roka", type: "date", required: true },
    { key: "status", label: "Status", type: "select", options: STATUS },
    { key: "note", label: "Napomena", type: "textarea", full: true },
  ];

  return (
    <CrudPage
      title="Rokovi"
      subtitle="Praćenje bitnih datuma: ugovori, registracije, pregledi, vatrogasni aparati, servisi (sa upozorenjima)"
      endpoint="deadlines"
      columns={columns}
      fields={fields}
      testid="deadlines"
      emptyDefaults={{ category: "Ostalo", status: "Aktivno" }}
      filterOptions={{ key: "category", label: "Kategorija", type: "rokovi" }}
      groupBy="category"
    />
  );
}
